import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  IconButton,
  TableCell,
  MenuItem,
  TableRow,
  Tooltip,
  Select,
  Button,
  Checkbox,
  withStyles,
} from "@material-ui/core";
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import NumberFormat from 'react-number-format';
import InfoIcon from '@material-ui/icons/Info';
import DeleteIcon from '@material-ui/icons/Delete';
import CachedIcon from '@material-ui/icons/Cached';
import { red, blue } from '@material-ui/core/colors';
import MessageIcon from '@material-ui/icons/Message';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import BackspaceIcon from '@material-ui/icons/Backspace';
import { ModalAfiliadoLiq } from '../../../UI/ModalAfiliadoLiq';
import { startAlerta } from '../../../../../actions/ui/alertas';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
// import InfoHistorialIcon from '../../../../autorizaciones/UI/InfoHistorialIcon';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { AUTORIZACIONES_COBRA_COSEGURO, CATEGORIAS_VALORIZACIONES_ARRAY, LIQUIDACIONES_LINEA_COMPORBANTE, LIQUIDACIONES_TIPO_INGRESO_LINEA, PRACTICA_ERROR_SUMA, PRACTICA_PRORROGA_AUTOMATICA } from '../../../../../utils/constants';
import { deleteLineaPrestacionNoGrabada, deleteLineaPrestacion, insertLineaPrestacion, updateLineaPrestacion, updateLineaPrestacionSinCalculoCoseguro } from '../../../../../actions/liquidaciones/liquidaciones';
import { AlertFinalizadoStepper } from '../../../../stepper/AlertFinalizadoStepper';
import { ModalNotaItem } from '../ModalNotaItem';
// import { ModalTrackingLineaComprobante } from '../ModalTrackingLineaComprobante';
import { validarSoloUnPermiso } from '../../../../../helpers/permisos';
import { LIQUIDACIONES_GESTION_PERMISOS } from '../../../../../utils/permisos';
import { Edit, PersonAddDisabled, SpeakerNotesSharp, WarningSharp } from '@material-ui/icons';
import { ModalModificarLinea } from './ModalModificarLinea';

const useStyles = makeStyles((theme) => ({
  iconInfo: {
    fontSize: "0.75rem"
  },
  cursorDefault: {
    cursor: 'default'
  }
}));

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: '1.2rem',       // Tamaño más grande del texto
    maxWidth: 300,            // Ancho máximo del tooltip
    padding: theme.spacing(2) // Padding interno opcional
  },
}))(Tooltip);

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const LineaPrestacionItem = ({ item, formatCurrencyPesos, disabledLinea, comprobanteSeleccionado, lineaComprobante }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );



  const [importe, setImporte] = useState(item.importe);
  const [cantidad, setCantidad] = useState(item.cantidad);
  const [idCategoria, setIdCategoria] = useState(item.idCategoria);
  const [fechaPrestacion, setFechaPrestacion] = useState(item.fechaPrestacion);
  const [afiliadoInexistente, setAfiliadoInexistente] = useState(item.afiliadoInexistente);
  const [practicaInexistente, setPracticaInexistente] = useState(item.practicaInexistente);
  const [fechaInternacionDesde, setFechaInternacionDesde] = useState(item.fechaInternacionDesde);
  const [fechaInternacionHasta, setFechaInternacionHasta] = useState(item.fechaInternacionHasta);
  const [nroValidacion, setNroValidacion] = useState(item.nroValidacion);
  const [idSolicitud, setIdSolicitud] = useState(item.idSolicitud);
  // const [idAgenda, setIdAgenda] = useState(item.idAgenda);
  const [openModalAfiliado, setOpenModalAfiliado] = useState(false);
  const [importeDebito, setImporteDebito] = useState(item.importeDebito);
  const [comentario, setComentario] = useState(item.comentario);
  const [afiliado, setAfiliado] = useState(
    { idAfiliado: item?.idAfiliado, carnet: item?.carnet, apellidoNombre: item?.apellidoNombre }
  );
  // const [openModalHistorialCambiosLinea, setOpenModalHistorialCambiosLinea] = useState(false);
  const [confirmarEliminar, setConfirmarEliminar] = useState(false);
  const [openModalNota, setOpenModalNota] = useState(false);
  const [deleteDebito, setDeleteDebito] = useState(false);
  const [coseguroFacturado, setCoseguroFacturado] = useState(item.coseguroFacturado);
  const [openModalModificarLinea, setOpenModalModificarLinea] = useState(false);
  const [comentarioCausa, setComentarioCausa] = useState(item.comentarioCausa);
  const [openModalNotaCausa, setOpenModalNotaCausa] = useState(false);
  const [grabarDebito, setGrabarDebito] = useState(false);
  const [idMotivoDebito, setIdMotivoDebito] = useState(item?.idMotivoDebito ? item.idMotivoDebito : 0);



  //const coseguroFact = item?.coseguroFacturado

  const coseguro = item?.idCobraCoseguro === AUTORIZACIONES_COBRA_COSEGURO.NO ? 0 : item.cantPracticasRealizadasAnoPrestacion >= item.tope
    ? item.valorExcedeExterno
    : item.valorExterno


  // const subtotal = (importe * cantidad) + coseguroFact)
  const subtotal = (importe * cantidad)

  // const subtotalCoseguroAplicado = subtotal - ((coseguro * cantidad) + coseguroFact)
  //const convenioCoseguroFacturadoDescontado = (!item.idModulo ? item.convenio : item.valorModulo) - coseguroFact

  const disabled = !item.esCodigoLiquidacion && item.lineaExistente

  const handleSaveLine = (deleteDebito = false) => {
    if (!importe || importe === 0) {
      dispatch(startAlerta("Debe ingresar un importe.", "warning", "Error"));
    }
    // else if (!item.esCodigoLiquidacion && importe < 0) {
    //   dispatch(startAlerta("El importe debe ser mayor a 0.", "warning", "Error"));
    // }
    // else if (!item.esCodigoLiquidacion && (!afiliado?.idAfiliado && !afiliadoInexistente)) {
    //   dispatch(startAlerta("Debe seleccionar un afliliado para grabar la línea.", "warning", "Error"));
    // }
    else if (item?.idTipoIngreso === LIQUIDACIONES_TIPO_INGRESO_LINEA.CARGA_POR_IDSOLICITUD && !fechaPrestacion) {
      dispatch(startAlerta("Debe cargar una fecha de prestación.", "warning", "Error"));
    }
    else if (checkDate()) {
      if (!item.lineaExistente && !grabarDebito)
        dispatch(insertLineaPrestacion(item.idComprobante, fechaPrestacion, item?.idCodNom,
          cantidad, importe, afiliado?.idAfiliado, idCategoria, fechaInternacionDesde,
          fechaInternacionHasta, nroValidacion, idSolicitud,
          afiliadoInexistente, practicaInexistente, false, comentarioCausa, idMotivoDebito));
      else
        debugger
      dispatch(updateLineaPrestacion(item.idItem, item.idComprobante,
        importe, deleteDebito ? 0 : importeDebito, fechaPrestacion, comentario,
        setOpenModalNota, setImporteDebito, item?.idCodNom,
        afiliadoInexistente, practicaInexistente, comentarioCausa, idMotivoDebito));
    }
  }


  const checkDate = () => {
    if (fechaInternacionDesde || fechaInternacionHasta) {
      if (!fechaInternacionDesde || !fechaInternacionHasta) {
        dispatch(startAlerta("Al indicar Fecha Internación Desde la Fecha Internación Hasta es requerida.", "warning", "Error"));
        return false;
      }

      if (moment(fechaPrestacion).isBefore(moment(fechaInternacionDesde), "day") || moment(fechaPrestacion).isAfter(moment(fechaInternacionHasta), "day")) {
        dispatch(startAlerta("Verifique las fechas.", "warning", "Error"));
        return false;
      }
    }

    return true;
  }



  useEffect(() => {
    setImporte(item?.importe);
    setCantidad(item?.cantidad);
    setIdCategoria(item.idCategoria);
    setFechaPrestacion(item?.fechaPrestacion);
    setAfiliadoInexistente(item?.afiliadoInexistente);
    setPracticaInexistente(item?.practicaInexistente);
    setNroValidacion(item?.nroValidacion);
    setIdSolicitud(item?.idSolicitud);
    setImporteDebito(item?.importeDebito);
    setAfiliado({ idAfiliado: item?.idAfiliado, carnet: item?.carnet, apellidoNombre: item?.apellidoNombre });
    setCoseguroFacturado(item?.coseguroFacturado);
  }, [item])

  return (
    <>
      <CustomTooltip title={item?.errorCoseguro === true ? "Error en coseguro" : ""} arrow>
        <TableRow style={{ backgroundColor: item?.errorCoseguro === true ? '#ff7961' : 'inherit' }}>
          {/* <TableCell align="center" sx={{ padding: "10px" }}>
          <div style={{ display: 'flex' }}>
            {openModalHistorialCambiosLinea &&
              <ModalTrackingLineaComprobante
                open={openModalHistorialCambiosLinea}
                closeModalHandler={() => {
                  setOpenModalHistorialCambiosLinea(false);
                }}
                idTipoLinea={LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION}
                idComprobante={item.idComprobante}
                idItem={item.idItem}
              />
            }
            {!item.newLine &&
              <InfoHistorialIcon

                onClick={() => setOpenModalHistorialCambiosLinea(true)}
              />
            }
          </div>
        </TableCell> */}
          <TableCell component="th" scope="row" style={{ fontSize: "0.75rem" }}>
            {/* {(item.idTipoIngreso === LIQUIDACIONES_TIPO_INGRESO_LINEA.CARGA_MANUAL || item.newLine) && */}
            <>
              {!disabledLinea &&
                <Tooltip
                  title={
                    <>
                      <span className={classes.iconInfo}>
                        {`Eliminar Linea`}
                      </span>
                    </>
                  }
                >
                  <IconButton style={{ padding: 0, marginLeft: 4 }}
                    color="inherit"
                    onClick={() => {
                      if (!item.newLine)
                        setConfirmarEliminar(true);
                      else
                        dispatch(deleteLineaPrestacionNoGrabada(item.idItem))
                    }}
                  >
                    <BackspaceIcon style={{ color: red[600] }} />
                  </IconButton>
                </Tooltip>
              }
              <AlertFinalizadoStepper
                open={confirmarEliminar}
                pregunta={"Eliminar línea"}
                dialogText={`Esta seguro de eliminar la línea?`}
                buttonCancel={"Cancelar"}
                buttonSubmit={"Confirmar"}
                handleClose={() => setConfirmarEliminar(false)}
                handleSend={() => {
                  dispatch(deleteLineaPrestacion(item.idItem, item?.idCodNom, item.idComprobante, item.idAfiliado, afiliadoInexistente, practicaInexistente));
                  setConfirmarEliminar(false);
                }}
              />
            </>
            {/* } */}
          </TableCell>
          <TableCell align="center" sx={{ padding: "10px" }}>
            <div style={{ display: 'flex' }}>
              {openModalModificarLinea &&
                <ModalModificarLinea
                  open={openModalModificarLinea}
                  closeModalHandler={() => {
                    setOpenModalModificarLinea(false);
                  }}
                  idTipoLinea={LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION}
                  idComprobante={item.idComprobante}
                  comprobanteSeleccionado={comprobanteSeleccionado}
                  lineaComprobante={lineaComprobante}
                  idItem={item.idItem}
                  item={item}
                  esLineaCodigoLiq={item?.esCodigoLiquidacion}
                  title="Modificar Linea Prestacion"
                  importeDebito={importeDebito}
                  setImporteDebito={setImporteDebito}
                />
              }
              {!item.newLine &&
                <IconButton onClick={() => setOpenModalModificarLinea(true)}>
                  <Edit
                    color="primary"
                  />
                </IconButton>
              }
            </div>
          </TableCell>
          <TableCell align="center" sx={{ padding: "10px" }}>
            <Tooltip
              title={
                <>
                  <span className={classes.iconInfo}>
                    {`Sin débito coseguro`}
                  </span>
                </>
              }
            >
              <Checkbox
                color="primary"
                checked={item?.sinDebitoCoseguro || false}
                disabled={item?.sinDebitoCoseguro ? true : false}
                onChange={(e) => dispatch(updateLineaPrestacionSinCalculoCoseguro(item.idItem, item.idComprobante))}
              />
            </Tooltip>
          </TableCell>
          <TableCell>
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{
                fontWeight: 'bold',
                color: '#fff',
                backgroundColor: item?.fechaPrestacion > comprobanteSeleccionado?.fechaInicioVigencia
                  ? 'red'
                  : importeDebito < 0
                    ? 'orange'
                    : 'black',
                padding: '0.2rem 0.5rem',
                borderRadius: '4px'
              }}>
                {item.nroLinea}
              </span>
              {item.lineaDuplicada && (
                <Tooltip
                  title={
                    <span className={classes.iconInfo}>
                      {`Linea Duplicada. Revisar Contrato`}
                    </span>
                  }
                >
                  <IconButton style={{ padding: 0, marginLeft: 4 }} color="inherit">
                    <InfoIcon style={{
                      fontSize: '1.5rem',
                      color: 'red',
                      marginLeft: '0.3rem',
                      animation: 'blink 1s infinite'
                    }} />
                  </IconButton>
                </Tooltip>

              )}
            </span>
            <style>
              {`
                @keyframes blink {
                  0%, 100% { opacity: 1; }
                  50% { opacity: 0; }
                }
              `}
            </style>
          </TableCell>
          <TableCell component="th" scope="row" style={{ textAlign: 'center', fontSize: "0.75rem" }}>
            {afiliado?.carnet && (
              <>
                <span
                  style={{
                    backgroundColor: item.fechaBajaAfiliado !== null ? 'yellow' : 'transparent',
                    padding: '0.2rem', // Opcional, para mejorar el espaciado visual
                    borderRadius: '4px' // Opcional, para bordes redondeados
                  }}
                >
                  {afiliado?.carnet} / {afiliado?.apellidoNombre}
                </span>
                {item?.idAfiliadoExterno && (
                  <span style={{ color: 'red', fontWeight: 'bold' }}> / O.S EXTERNA</span>
                )}
                {item?.fechaBajaAfiliado !== null && (
                  <Tooltip title="Afiliado de baja">
                    <WarningSharp
                      style={{
                        fontSize: '1rem',  // Tamaño reducido del ícono
                        color: 'red',
                        marginLeft: '0.3rem',  // Espacio entre el ícono y el texto
                      }}
                    />
                  </Tooltip>
                )}
              </>
            )}
            {afiliadoInexistente &&
              <Tooltip
                title={
                  <>
                    <span className={classes.iconInfo}>
                      {`Afiliado Inexistente`}
                    </span>
                  </>
                }
              >
                <IconButton style={{ padding: 0, marginLeft: 4 }}
                  color="inherit"
                  className={classes.cursorDefault}
                >
                  <PersonAddDisabled style={{ color: red[600] }} />
                </IconButton>
              </Tooltip>
            }
            {afiliadoInexistente &&
              ` ${afiliadoInexistente}`
            }
            <div style={{ display: 'inline-flex' }}>
              {(item.esCodigoLiquidacion || !item.lineaExistente || item.afiliadoInexistente) &&
                <Tooltip
                  title={
                    <>
                      <span className={classes.iconInfo}>
                        {`${afiliado?.idAfiliado || afiliadoInexistente
                          ? 'Cambiar Afiliado'
                          : !item.lineaExistente
                            ? 'Seleccionar Afiliado'
                            : 'Sin Afiliado'}`}
                      </span>
                    </>
                  }
                >
                  <IconButton
                    color="inherit"
                    className={(item.lineaExistente && !item.afiliadoInexistente && !item.esCodigoLiquidacion) && classes.cursorDefault}
                    onClick={() => {
                      if (!item.lineaExistente || item.afiliadoInexistente || item.esCodigoLiquidacion) setOpenModalAfiliado(true)
                    }}
                  >
                    {afiliado?.idAfiliado || afiliadoInexistente
                      ?
                      <CachedIcon />
                      :
                      <PersonOutlineIcon />
                    }
                  </IconButton>
                </Tooltip>
              }
              {true &&
                <ModalAfiliadoLiq
                  open={openModalAfiliado}
                  onCloseModal={() => {
                    setOpenModalAfiliado(false);
                  }}
                  setAfiliado={setAfiliado}
                  lineaExistente={item.lineaExistente}
                  esCodigoLiquidacion={item.esCodigoLiquidacion}
                  showAfiInexistente={!item.esCodigoLiquidacion}
                  setAfiliadoInexistente={setAfiliadoInexistente}
                />
              }
              {
                item.idAfiliado === null && !afiliadoInexistente &&
                <div style={{ color: 'red', fontWeight: 'bold' }}>
                  Afiliado sin asignar
                </div>
              }
            </div>
          </TableCell>
          <TableCell component="th" scope="row">
            {item.codNom ? item.codNom : practicaInexistente ?
              <Tooltip title="Practica Inexistente">
                <WarningSharp
                  style={{ display: 'flex', alignItems: 'center', color: 'red' }}
                />
              </Tooltip>
              :
              <Tooltip title="Código sin asignar">
                <WarningSharp
                  style={{ display: 'flex', alignItems: 'center', color: 'red' }}
                />
              </Tooltip>
            }
          </TableCell>
          <TableCell component="th" scope="row" style={{ fontSize: "0.75rem" }}>
            {item?.desNom &&
              `${item?.desNom?.substring(0, 25)}${item?.desNom?.length > 25 ? '... ' : ''}`
            }
            {item?.desNom && !practicaInexistente && item?.desNom?.length > 25 &&
              <Tooltip
                title={
                  <>
                    <span className={classes.iconInfo}>
                      {item?.desNom}
                    </span>
                  </>
                }
              >
                <span><strong>
                  {'VER'}
                </strong></span>
              </Tooltip>
            }
            {practicaInexistente && item?.desNom === null &&
              `${item?.practicaInexistente?.substring(0, 25)}${item?.practicaInexistente.length > 25 ? '... ' : ''}`
            }

            {practicaInexistente && item?.desNom === null && item?.practicaInexistente?.length > 25 &&
              <Tooltip
                title={
                  <>
                    <span className={classes.iconInfo}>
                      {item?.practicaInexistente}
                    </span>
                  </>
                }
              >
                <span><strong>
                  {'VER'}
                </strong></span>
              </Tooltip>
            }
            {item?.desNom === null && !practicaInexistente &&
              <div style={{ color: 'red', fontWeight: 'bold' }}>
                Código sin asignar
              </div>
            }

          </TableCell>

          <TableCell align="center" style={{ fontSize: "0.75rem" }}>
            {/* <MuiPickersUtilsProvider
            locale={esLocale}
            utils={DateFnsUtils}
          >
            <KeyboardDatePicker
              margin="normal"
              style={{ minWidth: 145 }}
              id="dialogFechaPrestacion"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              required={true}
              disabled={(disabled && item.idTipoIngreso !== LIQUIDACIONES_TIPO_INGRESO_LINEA.CARGA_POR_IDSOLICITUD) ||
                (item.esCodigoLiquidacion && item.lineaExistente)
              }
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              // minDate={fechaInternacionDesde ?? fechaInternacionDesde}
              minDate={fechaInternacionDesde !== null ? fechaInternacionDesde : undefined}
              minDateMessage={"La fecha Prestación no puede ser menor a la Fecha Internación Desde"}
              maxDate={fechaInternacionHasta !== null ? fechaInternacionHasta : new Date()}
              maxDateMessage={"La fecha Prestación no puede ser mayor a la Fecha Internación Hasta"}
              // minDate={idEfHorario===0 && new Date()}
              // minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
              value={
                moment(fechaPrestacion).isValid()
                  ? moment(fechaPrestacion)
                  : null
              }
              onChange={(date) => {
                setFechaPrestacion(date);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider> */}
            {item?.fechaPrestacion !== null ?
              <>
                {new Date(item.fechaPrestacion).toLocaleString("es", optionsfecha)}
              </>
              :
              <div style={{ color: 'red', fontWeight: 'bold' }}>
                Fecha inválida
              </div>
            }

          </TableCell>
          <TableCell align="right" style={{ fontSize: "0.75rem" }}>
            {/* <TextField
            margin="normal"
            name="cantidad"
            value={cantidad}
            autoComplete="off"
            disabled={disabled || (item.esCodigoLiquidacion && item.lineaExistente)}
            onChange={(e) => {
              if (e.target.value > 0) setCantidad(e.target.value)
            }}
            type='number'
            required
          //fullWidth
          /> */}
            {item.cantidad}
          </TableCell>
          <TableCell align="left" style={{ fontSize: "0.75rem" }}>
            <NumberFormat
              style={{ maxWidth: 100 }}
              onValueChange={(values) => {
                setImporte((!item.esCodigoLiquidacion && values.floatValue < 0) ? (values.floatValue * -1) : values.floatValue);
              }}
              value={importe}
              disabled
              // disabled={(disabled && item.importe !== 0) || disabledLinea}
              thousandSeparator="."
              decimalSeparator=","
              // isNumericString
              prefix={"$ "}
            />
          </TableCell>
          <TableCell align="center" style={{ fontSize: "0.75rem" }}>
            {item.lineaExistente &&
              <span style={{ fontWeight: 'bold', color: '#fff', backgroundColor: '#b22222', padding: '0.2rem 0.5rem', borderRadius: '4px' }}>
                {formatCurrencyPesos(!item.idModulo ? item.convenio : item.valorModulo)}
              </span>
            }
          </TableCell>
          {false &&
            <TableCell align="center" style={{ fontSize: "0.75rem" }}>
              {!item.esCodigoLiquidacion &&
                <MuiPickersUtilsProvider
                  locale={esLocale}
                  utils={DateFnsUtils}
                >
                  <KeyboardDatePicker
                    margin="normal"
                    style={{ minWidth: 145 }}
                    id="dialogFechaInternacionDesde"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    disabled={disabled}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    maxDate={fechaInternacionHasta ?? fechaInternacionHasta}
                    maxDateMessage={`La fecha no puede ser posterior a la Fecha Internación Hasta`}
                    value={
                      moment(fechaInternacionDesde).isValid()
                        ? moment(fechaInternacionDesde)
                        : null
                    }
                    onChange={(date) => {
                      setFechaInternacionDesde(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              }
            </TableCell>
          }
          {false &&
            <TableCell align="center" style={{ fontSize: "0.75rem" }}>
              {!item.esCodigoLiquidacion &&
                <MuiPickersUtilsProvider
                  locale={esLocale}
                  utils={DateFnsUtils}
                >
                  <KeyboardDatePicker
                    margin="normal"
                    style={{ minWidth: 145 }}
                    id="dialogFechaInternacionHasta"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    disabled={disabled}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    maxDate={new Date()}
                    value={
                      moment(fechaInternacionHasta).isValid()
                        ? moment(fechaInternacionHasta)
                        : null
                    }
                    onChange={(date) => {
                      setFechaInternacionHasta(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              }
            </TableCell>
          }
          {comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaPortalPrestador &&
            <TableCell align="right" style={{ fontSize: "0.75rem" }}>
              {/* <TextField
              margin="normal"
              name="nroValidacion"
              value={nroValidacion ?? ''}
              autoComplete="off"
              disabled={disabled || item.lineaExistente}
              onChange={(e) => { setNroValidacion(e.target.value) }}
              type='number'
            //fullWidth
            /> */}
              {nroValidacion ?? ''}
            </TableCell>
          }
          {comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaAutorizacion &&
            <TableCell align="right" style={{ fontSize: "0.75rem" }}>
              {/* <TextField
             fullWidth
              margin="normal"
              name="idSolicitud"
              value={idSolicitud}
              autoComplete="off"
              disabled={disabled || item.lineaExistente}
              onChange={(e) => { setIdSolicitud(e.target.value) }}
              type='number'
            //fullWidth
            /> */}
              {idSolicitud}
            </TableCell>
          }
          {/* <TableCell align="right">
              <TextField
                margin="normal"
                name="idAgenda"
                value={idAgenda}
                autoComplete="off"
                disabled={disabled}
                onChange={(e) => {setIdAgenda(e.target.value)}}
                type='number'
                //fullWidth
              />
            </TableCell> */}
          <TableCell align="left" style={{ fontSize: "0.75rem" }}>{`${formatCurrencyPesos(subtotal)}`}</TableCell>
          <TableCell align="center"
            style={{
              fontSize: "0.75rem",
            }}>
            {item.lineaExistente && !item.idModulo && (
              <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                <span style={{ fontWeight: 'bold', color: '#fff', backgroundColor: '#b22222', padding: '0.2rem 0.5rem', borderRadius: '4px' }}>
                  {formatCurrencyPesos(coseguro)}
                </span>
                {item.afiliadoExento && (
                  <Tooltip title="Afiliado exento">
                    <WarningSharp
                      style={{
                        color: 'red',
                        fontSize: '1rem',
                        marginLeft: '0.5rem',
                        cursor: 'pointer'
                      }}
                    />
                  </Tooltip>
                )}
              </span>
            )}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "0.75rem" }}>
            <NumberFormat
              style={{ maxWidth: 100 }}
              onValueChange={(values) => {
                setCoseguroFacturado((!item.esCodigoLiquidacion && values.floatValue < 0) ? (values.floatValue * -1) : values.floatValue);
              }}
              value={coseguroFacturado}
              disabled={true}
              thousandSeparator="."
              decimalSeparator=","
              // isNumericString
              prefix={"$ "}
            />
          </TableCell>
          {/* <TableCell align="center">
          {!item.idModulo &&
            formatCurrencyPesos(subtotalCoseguroAplicado)
          }
        </TableCell> */}
          <TableCell style={{ fontSize: "0.75rem" }}>
            {!item.esCodigoLiquidacion &&
              <Select
                fullWidth
                label="Categoria"
                name="idCategoria"
                value={idCategoria ?? ''}
                onChange={(e) => setIdCategoria(e.target.value)}
                disabled={disabled}
              >
                <MenuItem value={""}><em>Seleccione...</em></MenuItem>
                {CATEGORIAS_VALORIZACIONES_ARRAY.map(e => <MenuItem key={e.id} value={e.id}>{e.descripcion}</MenuItem>)}
              </Select>
            }
          </TableCell>

          {/* <TableCell align="center" style={{ fontSize: "0.75rem" }}>
          {!item.idModulo &&
            formatCurrencyPesos(convenioCoseguroFacturadoDescontado)
          }
        </TableCell> */}

          <TableCell align="center" style={{ fontSize: "0.75rem" }}>
            <div style={{ display: 'flex' }}>
              {importeDebito < 0 &&
                <>
                  {!disabledLinea &&
                    <Tooltip
                      title={
                        <>
                          <span className={classes.iconInfo}>
                            {`Agregar causa del debito`}
                          </span>
                        </>
                      }
                    >
                      <IconButton style={{ padding: 0, marginLeft: 4 }}
                        disabled={!validarSoloUnPermiso(permisosUser, LIQUIDACIONES_GESTION_PERMISOS.MODIFICAR_DEBITO)}
                        color="inherit"
                        onClick={() => {
                          setOpenModalNotaCausa(true);
                          setGrabarDebito(true);
                        }}
                      >
                        <SpeakerNotesSharp style={{ color: validarSoloUnPermiso(permisosUser, LIQUIDACIONES_GESTION_PERMISOS.MODIFICAR_DEBITO) }} />
                      </IconButton>
                    </Tooltip>
                  }
                </>
              }
              {item.idMotivoDebito &&
                <>
                  {!disabledLinea &&
                    <Tooltip
                      title={
                        <>
                          <span className={classes.iconInfo}>
                            {`Eliminar Debito`}
                          </span>
                        </>
                      }
                    >
                      <IconButton style={{ padding: 0, marginLeft: 4 }}
                        disabled={!validarSoloUnPermiso(permisosUser, LIQUIDACIONES_GESTION_PERMISOS.MODIFICAR_DEBITO)}
                        color="inherit"
                        onClick={() => {
                          setDeleteDebito(true);
                          setOpenModalNota(true);
                        }}
                      >
                        <DeleteIcon style={{ color: validarSoloUnPermiso(permisosUser, LIQUIDACIONES_GESTION_PERMISOS.MODIFICAR_DEBITO) && red[600] }} />
                      </IconButton>
                    </Tooltip>
                  }
                  <Tooltip
                    title={
                      <>
                        <span className={classes.iconInfo}>
                          {`DEBITO: ${item.motivoDebito}`}
                        </span>
                      </>
                    }
                    className={classes.cursorDefault}
                  >
                    <IconButton style={{ padding: 0, marginLeft: 4 }}
                      color="inherit"
                    >
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                </>
              }
              {item.idModulo &&
                <Tooltip
                  title={
                    <>
                      <span className={classes.iconInfo}>
                        {`MODULO Cod: ${item.codigoModulo} - ${item.descripcionModulo}`}
                      </span>
                    </>
                  }
                  className={classes.cursorDefault}
                >
                  <IconButton style={{ padding: 0, marginLeft: 4 }}
                    color="inherit"
                  >
                    <LocalAtmIcon style={{ color: blue[600] }} />
                  </IconButton>
                </Tooltip>
              }
              {item.lineaExistente && (item?.idCodNom !== PRACTICA_ERROR_SUMA.ID_COD_NOM &&
                item?.idCodNom !== PRACTICA_PRORROGA_AUTOMATICA.ID_COD_NOM) &&
                <NumberFormat
                  style={{ maxWidth: 100, marginLeft: 10 }}
                  onValueChange={(values) => {
                    setDeleteDebito(false);
                    setImporteDebito(values.floatValue > 0 ? -values.floatValue : values.floatValue);
                  }}
                  // isAllowed={(values) => {
                  //   const { floatValue } = values;
                  //   return floatValue >= (-importe * cantidad) || !floatValue;
                  // }}
                  value={!importeDebito ? 0 : importeDebito}
                  // disabled={(!item.lineaExistente || item.esCodigoLiquidacion || disabledLinea ||
                  //   !validarSoloUnPermiso(permisosUser, LIQUIDACIONES_GESTION_PERMISOS.MODIFICAR_DEBITO))
                  // }
                  thousandSeparator="."
                  decimalSeparator=","
                  // isNumericString
                  prefix={"$ "}
                />
              }
              {item.comentario &&
                <Tooltip
                  title={
                    <>
                      <span className={classes.iconInfo}>
                        {item.comentario}
                      </span>
                    </>
                  }
                >
                  <IconButton style={{ padding: 0, marginLeft: 10, color: '#37AFE1' }}
                    color="inherit"
                  >
                    <MessageIcon /* style={{ color: red[600] }} */ />
                  </IconButton>
                </Tooltip>
              }
            </div>
          </TableCell>
          <TableCell align="center" style={{ fontSize: "0.75rem" }}>                {/* TOTAL A PAGAR */}
            {formatCurrencyPesos(((importe) * cantidad) + (item.importeDebito ?? 0) - (item?.importeDebitoCalculadoCos ?? 0))}
          </TableCell>
          <TableCell style={{ fontSize: "0.75rem" }}>
            <Button
              style={{ fontSize: "0.8rem", backgroundColor: item?.comentario || item?.modificado ? '#37AFE1' : '' }}
              disabled={disabledLinea}
              onClick={() => {
                if (importeDebito ?? 0)
                  if (importeDebito && importeDebito > 0)
                    dispatch(startAlerta("El Importe Débito no puede ser mayor a cero.", "warning", "Error"));
                  else {
                    setOpenModalNota(true);
                    setGrabarDebito(true);
                  }
                else
                  handleSaveLine();
              }}
              variant="contained"
              color="primary"
            >
              Grabar
            </Button>
            <ModalNotaItem
              open={openModalNota}
              close={() => {
                setOpenModalNota(false);
                setDeleteDebito(false);
                setGrabarDebito(false);
              }}
              titulo={"Agregar Nota Modificación Débito"}
              carMin={10}
              carMax={2000}
              comentario={comentario}
              setComentario={setComentario}
              idMotivoDebito={idMotivoDebito}
              setIdMotivoDebito={setIdMotivoDebito}
              handleSaveLine={() => {
                if (deleteDebito)
                  setImporteDebito(0);
                handleSaveLine(deleteDebito);
              }}
              grabarDebito={grabarDebito}
            />
            <ModalNotaItem
              open={openModalNotaCausa}
              close={() => {
                setOpenModalNotaCausa(false);
                setDeleteDebito(false);
                setGrabarDebito(false);
              }}
              titulo={`Agregar Causa del Debito`}
              carMin={item.esCodigoLiquidacion ? 0 : 10}
              carMax={3000}
              comentario={comentarioCausa}
              setComentario={setComentarioCausa}
              esCodigoLiquidacion={item.esCodigoLiquidacion}
              handleSaveLine={() => {
                setOpenModalNotaCausa(false);
              }}
              idMotivoDebito={idMotivoDebito}
              setIdMotivoDebito={setIdMotivoDebito}
              grabarDebito={grabarDebito}
            />
          </TableCell>
        </TableRow>
      </CustomTooltip>
    </>
  );
}